import { useState } from 'react'
import PropTypes from 'prop-types'
import AppBrandIcon from './AppBrandIcon'
import { DEFAULT_LOGO_SRC } from 'utils/logo.utils'

const sizeClasses = {
  md: 'w-20 h-20',
  lg: 'w-48 h-40'
}

const AppBrandLogo = ({
  size = 'lg',
  className = ''
}) => {
  const [showIconFallback, setShowIconFallback] = useState(false)

  if (showIconFallback) {
    return <AppBrandIcon size={size === 'lg' ? 'lg' : 'md'} className={className} />
  }

  return (
    <div className={`${sizeClasses[size] || sizeClasses.lg} bg-white border border-gray-200 rounded-lg p-2 flex items-center justify-center shadow-sm ${className}`}>
      <img
        src={DEFAULT_LOGO_SRC}
        alt='GreenAmex logo'
        className='w-full h-full object-contain'
        onError={() => setShowIconFallback(true)}
      />
    </div>
  )
}

AppBrandLogo.propTypes = {
  size: PropTypes.oneOf(['md', 'lg']),
  className: PropTypes.string
}

export default AppBrandLogo
